import "./Header.scss";

import { CaretLeft } from "phosphor-react";
import { ReactNode } from "react";

import HelpModal from "@components/HelpModal";
import RunwayLogo from "@img/RunwayLogo.svg";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core/styles";
import { LANDING_PAGE } from "@utils/constantsEnv";

interface HeaderProps {
  progress?: number;
  background?: string;
  hideBackButton?: boolean;
  hasProgressBar?: boolean;
  isCheckout?: boolean;
  previous?: () => void;
  progressIndicator?: ReactNode;
}

const Header = ({
  progress,
  background,
  previous,
  hideBackButton = false,
  hasProgressBar = true,
  isCheckout = false,
  progressIndicator,
}: HeaderProps) => {
  const classes = makeStyles({
    root: {
      barColorPrimary: {
        backgroundColor: "#AAC4F9",
      },
    },
  })();
  return (
    <header className="rw-header" style={{ backgroundColor: background }}>
      <nav className="navbar">
        <button
          type="button"
          className="back-button"
          aria-label="Back"
          onClick={previous}
          style={{ visibility: !hideBackButton ? "visible" : "hidden" }}
        >
          <CaretLeft size={32} weight="bold" color="#5F80C8" aria-hidden="true" />
          <span>Back</span>
        </button>
        {!isCheckout ? (
          <a className="runway-logo" href={LANDING_PAGE} target="_blank" rel="noopener noreferrer">
            <img src={RunwayLogo} alt="Runway Health" />
          </a>
        ) : (
          <a className="runway-logo" href="#">
            <img src={RunwayLogo} alt="Runway Health" />
          </a>
        )}
        <HelpModal />
      </nav>
      {hasProgressBar &&
        (progressIndicator ?? (
          <div className={classes.root}>
            <LinearProgress variant="determinate" value={progress} />
          </div>
        ))}
    </header>
  );
};

export default Header;
